import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CartService } from '../../services/cart.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NotificationService } from '@app/services/notification.service';
import { WhatsAppService } from '@app/services/whatsapp.service';

import { GalaxyButtonDirective } from '@app/directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '@app/directives/galaxy-ripple.directive';
import { EliteAnnouncementBarComponent } from '../ui/elite-announcement-bar/elite-announcement-bar.component';

@Component({
  selector: 'app-header-user',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    GalaxyButtonDirective,
    GalaxyRippleDirective,
    EliteAnnouncementBarComponent,
  ],
  templateUrl: './header-user.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-user.component.css',
})
export class HeaderUserComponent {
  @Input() isScrollingDown = false;

  vm$: Observable<{ isLoggedIn: boolean; cartQuantity: number }>;
  searchQuery: string = '';

  constructor(
    private authService: AuthenticationService,
    private cartService: CartService,
    private notificationService: NotificationService,
    private router: Router,
    private whatsappService: WhatsAppService,
  ) {
    this.vm$ = combineLatest([
      this.authService.isLoggedIn$,
      this.cartService.quantity$,
    ]).pipe(
      map(([isLoggedIn, cartQuantity]) => ({ isLoggedIn, cartQuantity })),
    );
  }

  onSearch(): void {
    if (this.searchQuery.trim()) {
      this.router.navigate(['/tienda'], {
        queryParams: { q: this.searchQuery },
      });
      this.searchQuery = '';
    }
  }

  openSupportChat(): void {
    this.whatsappService.openGeneralSupportChat();
  }

  async logout(): Promise<void> {
    const result = await this.notificationService.confirm(
      '¿Cerrar sesión?',
      '¿Estás seguro de que quieres cerrar tu sesión?',
      'question',
    );
    if (result.isConfirmed) {
      this.authService.logout();
    }
  }
}
